/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserVaccinationScheduleDetails from './user-vaccination-schedule-details';
import UserVaccinationScheduleDetailsDetail from './user-vaccination-schedule-details-detail';
import UserVaccinationScheduleDetailsUpdate from './user-vaccination-schedule-details-update';
import UserVaccinationScheduleDetailsDeleteDialog from './user-vaccination-schedule-details-delete-dialog';

const UserVaccinationScheduleDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserVaccinationScheduleDetails />} />
    <Route path="new" element={<UserVaccinationScheduleDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<UserVaccinationScheduleDetailsDetail />} />
      <Route path="edit" element={<UserVaccinationScheduleDetailsUpdate />} />
      <Route path="delete" element={<UserVaccinationScheduleDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserVaccinationScheduleDetailsRoutes;
